import React from "react";

const BoardTitle = ({ text }) => {
  return <h2 className="font-bold text-xl p-1 border-b-2">{text}</h2>;
};

export { BoardTitle };
